import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchComfeSettings = () =>
  requestStateData(
    'comfeSettings',
    ({ signupSession: { comfeService } }: SignupState) =>
      comfeService.getSettings()
  )

export const useComfeSettings = () =>
  useStateData('comfeSettings', fetchComfeSettings)
